import React, { ReactNode } from "react";
import { Button, useTheme } from "@mui/material";
import { lighten } from "@mui/material/styles";
import { LoadingSlides } from "../../CommonComponents/Common";
import { commonStyles } from "../../../../assets/MUIStyles/commonStyles";
interface BaseButtonProps {
  title: any;
  handleClick: (e: React.FormEvent) => void;
  disabled?: boolean;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  variant?: "text" | "outlined" | "contained";
  styles?: any;
  loading?: boolean;
  type?: "button" | "submit" | "reset";
}
const BaseButton: React.FC<BaseButtonProps> = ({
  title,
  handleClick,
  disabled = false,
  startIcon,
  endIcon,
  styles = {},
  variant = "text",
  loading = false,
  type = "button",
}) => {
  const theme = useTheme();
  const brandColor = theme.custom.brandColor;
  const hoverColor =
    variant === "contained" ? lighten(brandColor, 0.2) : "transparent";

  const disabledBgColor =
    variant === "contained" ? lighten(brandColor, 0.4) : "transparent";

  return (
    <Button
      type={type}
      onClick={handleClick}
      disabled={disabled}
      startIcon={(!loading && startIcon) || undefined}
      endIcon={(!loading && endIcon) || undefined}
      variant={variant}
      sx={{
        ...commonStyles.baseButtonStyles(
          variant,
          brandColor,
          hoverColor,
          disabledBgColor
        ),
        ...styles,
      }}
    >
      {loading ? (
        <LoadingSlides bgColor={variant === "outlined" ? "#181818" : "white"} />
      ) : (
        title
      )}
    </Button>
  );
};
export default BaseButton;
